/*
 * vg-related-autoplay.js — Victoria's Gala
 * Activates Horizon's native <slideshow-component> autoplay + infinite
 * loop for the "También podría gustarte" section on PDPs.
 *
 * Uses ONLY the outer carousel (ref="resourceListCarousel") to avoid
 * affecting each product card's internal hover-swap slideshow.
 */
(function () {
  'use strict';

  var AUTOPLAY_SECONDS = 4;

  function isProductTemplate() {
    if (document.body && document.body.classList.contains('template-product')) return true;
    var main = document.querySelector('main[data-template]');
    if (main && main.getAttribute('data-template').indexOf('product') !== -1) return true;
    return false;
  }

  function activateAutoplay(slideshow) {
    if (!slideshow || slideshow.dataset.vgAutoplayActivated === '1') return;
    slideshow.dataset.vgAutoplayActivated = '1';

    if (!slideshow.hasAttribute('autoplay')) {
      slideshow.setAttribute('autoplay', String(AUTOPLAY_SECONDS));
    }
    if (!slideshow.hasAttribute('infinite')) {
      slideshow.setAttribute('infinite', '');
    }

    if (typeof slideshow.play === 'function') {
      try { slideshow.play(AUTOPLAY_SECONDS * 1000); } catch (e) { /* ignore */ }
    }
  }

  function initAll() {
    if (!isProductTemplate()) return;
    var recs = document.querySelectorAll('product-recommendations');
    for (var i = 0; i < recs.length; i++) {
      // ONLY the outer carousel — not inner card hover-swap galleries
      var slideshow = recs[i].querySelector('slideshow-component[ref="resourceListCarousel"]');
      if (slideshow) activateAutoplay(slideshow);
    }
  }

  function start() {
    initAll();
    setTimeout(initAll, 500);
    setTimeout(initAll, 1500);
    setTimeout(initAll, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
